import DashboardLayout from '../layouts/DashboardLayout'
// import CustomerSupport from '../pages/support/CustomerSupport'

export const supportMenuV2 = {
    path: '/customer-support-new',
    component: DashboardLayout,
    name: 'CustomerSupportV2',
    children: [
        {
            path: '/customer-support-new',
            component: () => import (/* webpackChunkName: "about" */'../pages/supportv2/CustomerSupport.vue'),
            meta: {
                roles: ['contact_read', 'dashboard_read'],
                requiresAuth: true,
                breadcrumb: [{
                    title: 'Hỗ trợ khách hàng'
                }]
            },
        },
    ],
}